<template>
  <ModalsTheModal>
    <div class="rounded-md bg-white-100 p-4 pt-10 lg:p-13">
      <SvgIcon
        name="close"
        class="icons-medium absolute right-3 top-3 cursor-pointer md:text-[#949494]"
        @click="() => modalsStore.closeModal()"
      />
      <div class="mb-8">
        <div class="mb-2 text-[32px] font-medium leading-10">
          Укажите, пожалуйста, род деятельности
        </div>
        <span class="text-[18px] leading-6 text-[#949494]"
          >Эти данные помогут нам подбирать более интересные статьи, лекции и
          материалы по истории России именно для вас.</span
        >
      </div>
      <div class="mb-8">
        <BaseTheDropdownSelectNew
          v-model="formData.activity_type_id"
          :list="types"
          class="mb-4"
          :error="v$.activity_type_id.$errors[0]?.$message"
        />
        <BaseTheInput
          v-if="formData.activity_type_id === OTHER_ACTIVITY"
          v-model="formData.activity_type_other"
          placeholder="Введите род деятельности"
          class="mb-4"
          is-redesign-auth
          :error="v$.activity_type_other.$errors[0]?.$message"
        />
        <BaseTheWrapperForLabel
          v-if="formData.activity_type_id === 1"
          label="Класс"
          required
          class="mb-3"
        >
          <BaseTheDropdownSelectNew
            v-model="formData.school_class"
            :list="classes"
            class="max-h-[54px] w-full"
            :error="v$.school_class.$errors[0]?.$message"
          />
        </BaseTheWrapperForLabel>
      </div>
      <BaseTheButtonNew
        type="secondary"
        text="Сохранить"
        is-small
        class="!w-full justify-center"
        @click="updateAtivityType"
      />
    </div>
  </ModalsTheModal>
</template>

<script setup>
import { useVuelidate } from '@vuelidate/core';
import { helpers, required, requiredIf } from '@vuelidate/validators';

import { validationErrors } from '@/assets/data/validateErrors';
import api from '@/services/api/api';

const OTHER_ACTIVITY = 255;

const toast = useToast();
const authStore = useAuthStore();
const modalsStore = useModalsStore();
const { CLASSES: classes } = useScoolClasses();
const { activityTypes } = useActivityTypes();
const types = computed(() => activityTypes?.data?.value);
const propsModal = computed(() => modalsStore.getPropsModal || {});

const formData = ref({
  activity_type_id: propsModal.value?.userData?.activity_type_id || null,
  activity_type_other: null,
  school_class: null,
});

const rules = computed(() => {
  return {
    activity_type_id: {
      required: helpers.withMessage(validationErrors.required, required),
    },
    activity_type_other: {
      required: helpers.withMessage(
        validationErrors.required,
        requiredIf(formData.value.activity_type_id === OTHER_ACTIVITY),
      ),
    },
    school_class: {
      required: helpers.withMessage(
        validationErrors.required,
        requiredIf(formData.value.activity_type_id === 1),
      ),
    },
  };
});

const v$ = useVuelidate(rules, formData);

const updateAtivityType = async () => {
  v$.value.$touch();

  if (v$.value.$invalid) {
    return 0;
  }

  if (!propsModal.value || !propsModal.value.userData) return;

  const user = {
    ...propsModal.value.userData,
    activity_type_id: formData.value.activity_type_id,
    activity_type_other: formData.value.activity_type_other,
    school_class: formData.value.school_class,
  };

  try {
    await api.user.updateUserInfo(user);
    await authStore.updateUserInfo();
    modalsStore.closeModal();
    toast.success('Профиль успешно обновлен!');
  } catch (e) {
    toast.error('Ошибка обновления профиля!');
    console.log(e);
  }
};
</script>
